import script from "./MemberRoleButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberRoleButton.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QMenu});
